var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapMarkerRequisitionPickupUnassigned(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 52,
    viewBox: "0 0 30 52",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.5558495.72207525c.962767-.962767 1.925534-.962767 2.888301 0l6.9512052 6.95120517c.6229669.62296689.7645502 1.35920047.4247501 2.20870077-.3398001.84950031-.962767 1.27425041-1.8689006 1.27425041h-2.8348031l.000407 1.4074636c6.2826698 1.7633164 10.8831909 7.4616466 10.8831909 14.2189135 0 5.4428062-5 13.8486033-15 25.2173913-10-11.368788-15-19.7745851-15-25.2173913 0-6.7572669 4.60052108-12.4555971 10.8831909-14.2189135l.000407-1.4074636h-2.83480307c-.90613365 0-1.52910053-.4247501-1.86890065-1.27425041-.33980012-.8495003-.19821674-1.58573388.42475015-2.20870077z",
    fill: "#f2ae00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 27,
    fill: "#1f5bc0",
    r: 11,
    stroke: "#fff",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarkerRequisitionPickupUnassigned);
export default __webpack_public_path__ + "static/media/map-marker-requisition-pickup-unassigned.655e2eb6916b4a492f7e81693c3c1aa2.svg";
export { ForwardRef as ReactComponent };